module.exports = __webpack_public_path__ + "assets/1538999bd188992c28b2941756848561.mp3";